<template>
  <div id="ecgChart" style="height: 500px">&nbsp;</div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    props: ['data'],
    data() {
      return {
        timer: null,
        currentTime: 0,
        lastDataShownAt: null
      }
    },
    methods: {
      ...mapActions(['shiftEcgData']),
      startRealtimeChart: () => {},
    },
    computed: {
      ...mapState(['ecgData', 'selectedPatient']),
      deviceId() {
        return this.selectedPatient.devices_ids ? this.selectedPatient.devices_ids[0] : null;
      },
    },
    mounted () {
      let ctrl = this;

      const addDataToBuffer = async (data) => {
        if (!data) {
          return;
        }
        const totalData = data.reduce((total, row) => {
          return total.concat(row.data);
        }, []);
        await this.$store.commit('setEcgData', totalData);
      };

      const getRowFromBuffer = () => {
        return this.shiftEcgData();
      };

      const prepareChartFunctionality = async () => {
        // Extract required parts from LightningChartJS.
        const {
          lightningChart,
          DataPatterns,
          AxisScrollStrategies,
          SolidLine,
          SolidFill,
          ColorHEX,
          AutoCursorModes
        } = lcjs;

        ctrl.startDataFollowing = () => {
          ctrl.chart.getDefaultAxisX()
            .setScrollStrategy(AxisScrollStrategies.progressive);
        };
// Create a XY Chart.
        const chart = lightningChart().ChartXY({
          // theme: Themes.dark
          containerId: 'ecgChart'
        }).setTitle('ECG');

        ctrl.chart = chart;

// Add line series to visualize the data received
        const series = chart.addLineSeries({ dataPattern: DataPatterns.horizontalProgressive });
        ctrl.series = series;
// Style the series
        series
          .setStrokeStyle(new SolidLine({
            thickness: 2,
            fillStyle: new SolidFill({ color: ColorHEX('#e72228') })
          }))
          .setMouseInteractions(false);

        chart.setAutoCursorMode(AutoCursorModes.disabled);

// Setup view nicely.
        chart.getDefaultAxisY()
          .setTitle('mV')
          .setInterval(-200, 200)
          .setScrollStrategy(AxisScrollStrategies.expansion);

        chart.getDefaultAxisX()
          .setTitle('milliseconds')
          .setInterval(-5000, 0)
          .setScrollStrategy(AxisScrollStrategies.progressive);

        const renderInterval = 300;


        this.startRealtimeChart = async (initial = true) => {
          if (initial) {
            series.setMaxPointCount(8000);
          }
          let renderedTime = 0;
          while (renderedTime <= renderInterval) {
            let data = this.ecgData.shift();
            if (!data) {
              this.timer = null;
              return;
            }
            const point = { x: this.currentTime, y: data.y };
            series.add(point);
            this.currentTime += data.x;
            renderedTime += data.x;
          }

          this.timer = setTimeout(async () => {
            await this.startRealtimeChart(false);
          }, renderInterval);
        };

        const renderBuffer = () => {
          const points = this.ecgData.map((el) => {
            this.currentTime += el.x;
            el.x = this.currentTime - el.x;
            return el;
          });
          series.add(points);
          this.$store.commit('clearEcgData');
          this.lastDataShownAt = new Date().valueOf();
          series.setMaxPointCount(100000);
        };

        const renderHistoryData = async () => {
          await addDataToBuffer(this.data);
          renderBuffer();
          if (this.deviceId) {
            this.$store.commit('setEcgActiveDevice', this.deviceId);
          }
        };

        await renderHistoryData();
      };

      this.$loadScript("/static/js/lcjs.iife.js")
        .then(async () => {
          await prepareChartFunctionality();
        });
    },
    watch: {
      ecgData(newValue, oldValue) {
        if (!this.timer && newValue.length > 0 && oldValue.length > 0) {
          let now = new Date().valueOf();
          if (now - this.lastDataShownAt > 10 * 1000) {
            const {
              AxisScrollStrategies,
            } = lcjs;
            this.series.clear();
            this.currentTime = 0;
            this.chart.getDefaultAxisX()
              .setInterval(-3000, 0)
              .setScrollStrategy(AxisScrollStrategies.progressive);
          }
          this.lastDataShownAt = now;
          this.timer = setTimeout(() => {
            this.startRealtimeChart();
          }, 1000);
        }
      },
    },
    destroyed() {
      this.$store.commit('setEcgActiveDevice', null);
      this.$store.commit('clearEcgData');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EcgChart.vue